import { z } from 'zod'

/**
 * Labor activity types for job costing.
 * Restricted subset of timesheet activities - only DRIVE-TIME and ON-SITE are relevant for costing.
 * IDLE and LUNCH from timesheet activities are excluded.
 */
export const LABOR_ACTIVITY_TYPES = ['DRIVE-TIME', 'ON-SITE'] as const
export type LaborActivityType = (typeof LABOR_ACTIVITY_TYPES)[number]

/** Zod schema for validating labor activity type */
export const LaborActivityTypeSchema = z.enum(LABOR_ACTIVITY_TYPES)

/** Display name helper for UI rendering */
export const laborActivityTypeDisplayName = (type: LaborActivityType): string => {
  switch (type) {
    case 'DRIVE-TIME':
      return 'Drive Time'
    case 'ON-SITE':
      return 'On-Site'
  }
}

const LABOR_ACTIVITY_TYPE_SET = new Set<string>(LABOR_ACTIVITY_TYPES)

export const isLaborActivityType = (raw: string): raw is LaborActivityType => {
  return LABOR_ACTIVITY_TYPE_SET.has(raw)
}

/**
 * Coerce a raw timesheet activity name to a labor activity type.
 * Returns null if the activity is not applicable for job costing (e.g., IDLE, LUNCH).
 */
export const coerceLaborActivityType = (raw?: string | null): LaborActivityType | null => {
  if (!raw) return null
  return isLaborActivityType(raw) ? raw : null
}
